/* eslint react/display-name: 0 */
import React from 'react'
import PropTypes from 'prop-types'
import R from 'ramda'
import { COLORS } from '_constants'

import { Menu, Grid, Dimmer, Loader } from 'semantic-ui-react'
import { getIsActiveAndNotExpiredLicensePool } from '_utils/licensePools';

import InstitutionAcsPage from '_views/activationCodes/institution'
import InstitutionKeys from '_views/keys'
import LineItem from '_views/lineItem'
import Usage from '_views/usage'
import UserInfo from '_views/userInfo'
import { OldLicensesDisplay } from "_/institutions/institution/oldLicensesDisplay";

const getAdmins = R.compose(
  R.defaultTo([]),
  R.path(['institution', 'administrators'])
)

const getAdminsAsUserInfo = R.compose(
  R.map(u => (<div key={`admin_${u._id}`} style={{paddingBottom: '1em'}}><UserInfo user={u} /></div>)),
  getAdmins
)
const InstitutionAccount = props => (
  <div>
    <LineItem label='Name' text={R.path(['institution', 'name'], props)} />
    <LineItem label='Contact name' text={R.path(['institution', 'contact_name'], props)} />
    <LineItem label='Contact email' text={R.path(['institution', 'contact_email'], props)} />
    <div><b>Administrators</b> : <div style={{display: 'inline-block', verticalAlign: 'top'}}>{getAdminsAsUserInfo(props) }</div></div>
  </div>
)

const INSTITUTION_PANES = {
  ACCOUNT: 'Account',
  ACTIVATIONCODES: 'Activation Codes',
  KEYS: 'Keys'
}

const getPane = R.cond([
  [
    R.pathEq(['state', 'active'], INSTITUTION_PANES.ACCOUNT),
    obj => (<InstitutionAccount institution={obj.props.institution} />)
  ],
  [
    R.pathEq(['state', 'active'], INSTITUTION_PANES.KEYS),
    obj => (<InstitutionKeys
      institution={R.path(['props', 'institution'], obj)}
      {...obj.props.keyFuncs}
    />)
  ],
  [
    R.pathEq(['state', 'active'], INSTITUTION_PANES.ACTIVATIONCODES),
    obj => (<InstitutionAcsPage
      { ...obj.props.acFuncs }
      { ...obj.props.acData }
      institution={ obj.props.institution }
      canNavigateUsers={ false }
    />)
  ],
  [
    R.T,
    obj => (<InstitutionAccount institution={obj.props.institution} />)
  ]
])

const InstitutionInfo = ({
  institution = {}
}) => {
  return (
    <React.Fragment>
      <LineItem label='Active License Pools' text={ !institution.license_pools ? 0 : institution.license_pools.filter(p => getIsActiveAndNotExpiredLicensePool(p)).length } />
      <OldLicensesDisplay count={ institution.oldlicense_count } />
      <br/>
      {
        (institution.license_pools || [])
          .filter(p => getIsActiveAndNotExpiredLicensePool(p))
          .map(p => <Usage key={ p._id } licensePool={ p } />)
      }
    </React.Fragment>
  )
}

InstitutionInfo.propTypes = {
  institution: PropTypes.object.isRequired
}

const InstitutionMenu = ({
  active,
  onMenuClick,
  onRefreshInstitution,
}) => (
  <Menu attached='top' color={COLORS.INSTITUTIONS.MENU} inverted pointing>
    <Menu.Menu position='left'>
      <Menu.Item name={INSTITUTION_PANES.ACCOUNT} icon='users' active={active === INSTITUTION_PANES.ACCOUNT} onClick={onMenuClick} />
      <Menu.Item name={INSTITUTION_PANES.ACTIVATIONCODES} icon='ticket' active={active === INSTITUTION_PANES.ACTIVATIONCODES} onClick={onMenuClick} />
      <Menu.Item name={INSTITUTION_PANES.KEYS} icon='key' active={active === INSTITUTION_PANES.KEYS} onClick={onMenuClick} />
    </Menu.Menu>

    <Menu.Menu position='right'>
      <Menu.Item icon='refresh' onClick={onRefreshInstitution} content='refresh'/>
    </Menu.Menu>
  </Menu>
);

InstitutionMenu.propTypes = {
  active: PropTypes.string.isRequired,
  onMenuClick: PropTypes.func.isRequired,
  onRefreshInstitution: PropTypes.func.isRequired
};

// this class uses static class properties for auto-binding
// https://babeljs.io/docs/plugins/transform-class-properties/
// https://github.com/tc39/proposal-private-fields

class InstitutionItem extends React.PureComponent {
  state = {
    active: INSTITUTION_PANES.ACCOUNT
  }
  onMenuClick = (_, data) => {
    this.setState({active: data.name})
  }

  // institution actions
  onRefreshInstitution= () => this.props.onRefreshInstitution({ institutionId: this.props.institution._id })

  render () {
    return (
      <Grid divided stackable>
        <Grid.Row>
          <InstitutionMenu
            institution={this.props.institution}
            active={R.prop('active', this.state)}
            onMenuClick={this.onMenuClick}
            onRefreshInstitution={this.onRefreshInstitution}
            onRemoveInstitution={this.onRemoveInstitution}
          />
        </Grid.Row>
        <Grid.Row >
          <Grid.Column width='4'>
            <InstitutionInfo institution={R.prop('institution', this.props)} />
          </Grid.Column>
          <Grid.Column width='12'>
            <Dimmer inverted active={this.props.isLoading === true}>
              <Loader />
            </Dimmer>
            { getPane(this) }
          </Grid.Column>
        </Grid.Row>
      </Grid>
    )
  }
}

InstitutionItem.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  institution: PropTypes.object.isRequired,
  // inst. functions
  onRefreshInstitution: PropTypes.func.isRequired,
  // inst. key funcs
  keyFuncs: PropTypes.object.isRequired,
  // inst. Activation Code functions
  acFuncs: PropTypes.object.isRequired,
  acData: PropTypes.object.isRequired
}

export default InstitutionItem;



// WEBPACK FOOTER //
// ./webAdmin/components/thirdParty/institution/index.js